import { type CSSProperties, type ReactNode } from 'react';
import { Classes } from '@blueprintjs/core';
import cx from 'clsx';

export type TooltipProps = Readonly<{
  top: number;
  left: number;
  offsetTop?: number;
  offsetLeft?: number;
  style?: CSSProperties;
  children?: ReactNode;
}>;

export const Tooltip = ({
  top: initialTop,
  left: initialLeft,
  offsetTop = 12,
  offsetLeft = 12,
  style,
  children,
}: TooltipProps) => {
  // Check if we're near the right edge of the screen
  const tooltipWidth = 200; // Approximate tooltip width
  const nearRightEdge = initialLeft + tooltipWidth + offsetLeft > window.innerWidth;

  const adjustedLeft = nearRightEdge
    ? initialLeft - tooltipWidth - offsetLeft // Position to the left
    : initialLeft + offsetLeft; // Position to the right
  const adjustedTop = initialTop + offsetTop;

  return (
    <div
      className={cx('Tooltip', Classes.POPOVER)}
      style={{
        ...style,
        position: 'fixed',
        top: adjustedTop,
        left: adjustedLeft,
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      <div className={cx('Tooltip-content', Classes.POPOVER_CONTENT)}>{children}</div>
    </div>
  );
};
